$('.js-gewaehrleistung_bild').magnificPopup({
    type: 'image'
});
